module.exports = __webpack_public_path__ + "static/img/Charlie-Staines.b13cb00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie-Staines.jpg
// module id = Q975
// module chunks = 0